import React from 'react'

const RejectWithoutBorder = ({ width, height }) => {
  return (
    <svg
      width={width || "34"}
      height={height || "34"}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.6719" cy="17" r="12" fill="#E50509" />
      <path
        d="M23.0401 10.3198C23.3132 10.5835 23.3431 11.0044 23.1245 11.3023L23.0588 11.3803L18.0233 16.5964L23.2407 21.6349C23.5387 21.9226 23.547 22.3974 23.2593 22.6954C22.9955 22.9685 22.5745 22.9982 22.2767 22.7797L22.1988 22.7139L16.9813 17.6755L11.9471 22.8914C11.6594 23.1894 11.1846 23.1979 10.8866 22.9102C10.6135 22.6464 10.5836 22.2255 10.8021 21.9277L10.8679 21.8496L15.9023 16.6335L10.6878 11.5979C10.3898 11.3101 10.3816 10.8353 10.6693 10.5374C10.9331 10.2643 11.354 10.2345 11.6519 10.4531L11.7298 10.5189L16.9443 15.5545L21.9796 10.3385C22.2673 10.0405 22.7421 10.032 23.0401 10.3198Z"
        fill="white"
      />
    </svg>
  );
}

export default RejectWithoutBorder